module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay hide",
    attrs: {
      "data-pages": "search"
    }
  }, [_c('div', {
    staticClass: "overlay-content has-results m-t-20"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "no-border overlay-search bg-transparent",
    attrs: {
      "id": "overlay-search",
      "placeholder": "Search...",
      "autocomplete": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('span', {
    attrs: {
      "id": "overlay-suggestions"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "search-results m-t-40"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Search Results")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.results), function(result) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [(result.type === 'item') ? _c('div', {
      staticClass: "search-result"
    }, [_c('div', {
      staticClass: "thumbnail-wrapper d48 text-white inline m-t-10"
    }, [_c('div', [(typeof result.item !== 'undefined' && Array.isArray(result.item.images) && result.item.images.length > 0) ? _vm._t("default", [_c('img', {
      attrs: {
        "width": "50",
        "height": "50",
        "src": '/api/' + result.item.images[0].path,
        "data-src": "./assets/img/profiles/avatar.jpg",
        "data-src-retina": "./assets/img/profiles/avatar2x.jpg",
        "alt": ""
      }
    })]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "p-l-10 inline p-t-5"
    }, [_c('h5', {
      staticClass: "m-b-0"
    }, [_c('span', {
      staticClass: "semi-bold result-name"
    }, [_vm._v(_vm._s(result.item.name))])]), _vm._v(" "), _vm._m(4, true, false)])]) : _vm._e()])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('a', {
    staticClass: "close-icon-light overlay-close text-black fs-16",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-close"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block"
  }, [_c('div', {
    staticClass: "checkbox right"
  }, [_c('input', {
    attrs: {
      "id": "checkboxn",
      "type": "checkbox",
      "value": "1",
      "checked": "checked"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search within page")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block m-l-10"
  }, [_c('p', {
    staticClass: "fs-13"
  }, [_vm._v("Press enter to search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('strong', [_vm._v("suggestions :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "small"
  }, [_vm._v("in "), _c('span', {
    staticClass: "semi-bold"
  }, [_vm._v("products")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba02d00"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/search.vue
// module id = 1349
// module chunks = 1